import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { func, bool, number } from 'prop-types';
import numeral from 'numeral';
import Radium from 'radium';
import { UTButton, UTLabel } from '@widergy/energy-ui';

import UTCheckbox from 'app/components/UTCheckbox';
import UTTouchableWithoutFeedback from 'app/components/UTTouchableWithoutFeedback';
import { accountPropTypes } from 'redux/accountHandlers';
import { message } from 'utils/stringUtils';
import Images from 'config/assets';
import { appConfig } from 'config/customization';

import stylesJS from './styles';
import styles from './styles.module.scss';

class DetailHeader extends PureComponent {
  render() {
    const {
      account,
      handleCheckAll,
      handleOnPress,
      isOpen,
      checkAll,
      accountTotalAmount,
      onOpenPaymentDocumentModal,
      isPublic
    } = this.props;

    return (
      <div style={stylesJS.header}>
        <div style={stylesJS.firstMobileRow}>
          <UTCheckbox onChange={handleCheckAll} value={checkAll} />
          <UTLabel small style={stylesJS.accountInfo}>
            {account.address}
          </UTLabel>
        </div>
        <div style={stylesJS.secondMobileRow}>
          <UTLabel large light darkGray className={styles.bar}>
            |
          </UTLabel>
          <UTLabel small style={stylesJS.nis}>
            {message('Payments:nis')}
            &nbsp;
            {account.client_number}
          </UTLabel>
          <UTLabel small bold alternative style={stylesJS.amount}>
            {numeral(accountTotalAmount).format('$0,0.[00]')}
          </UTLabel>
          {(!isPublic || !appConfig.payments.paymentForNis) && appConfig.payments.paymentDocumentModal && (
            <UTButton
              disabled={accountTotalAmount === 0}
              style={stylesJS.downloadButton}
              onPress={onOpenPaymentDocumentModal}
            >
              {message('AccountStatus:paymentDocument')}
            </UTButton>
          )}
        </div>
        <div style={stylesJS.actions}>
          <UTTouchableWithoutFeedback onClick={handleOnPress} style={isOpen && stylesJS.arrowDown}>
            <img src={Images.listArrowDown} alt="expand arrow" />
          </UTTouchableWithoutFeedback>
        </div>
      </div>
    );
  }
}

DetailHeader.propTypes = {
  account: accountPropTypes,
  accountTotalAmount: number,
  handleCheckAll: func,
  handleOnPress: func,
  onOpenPaymentDocumentModal: func,
  isOpen: bool,
  checkAll: bool,
  isPublic: bool
};

export default connect()(Radium(DetailHeader));
